module.exports = __webpack_public_path__ + "static/media/fontello.bb50c937.ttf";